import { B } from "../../design/tokens";

export default function Ticker() {
  const items = [
    "PRC Licensed Real Estate Broker", "SEC Registered OPC",
    "Licensed Environmental Planner", "RESA Compliant Practice",
    "Nationwide Service", "BIR Registered · RDO 028",
    "Title Transfer Specialists", "CLUP & EIA Experts",
  ];
  const full = [...items, ...items, ...items];
  return (
    <div style={{ background: `linear-gradient(90deg, ${B.royal} 0%, ${B.navyMid} 50%, ${B.royal} 100%)`, borderTop: `1px solid ${B.hairline}`, borderBottom: `1px solid ${B.hairline}`, padding: "15px 0", overflow: "hidden" }}>
      <div style={{ display: "flex", gap: 0, animation: "ticker 44s linear infinite", width: "max-content" }}>
        {full.map((item, i) => (
          <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 28, paddingRight: 28 }}>
            <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, color: `${B.white}aa`, letterSpacing: 2, textTransform: "uppercase", whiteSpace: "nowrap", fontWeight: 500 }}>{item}</span>
            <span style={{ color: B.mist, fontSize: 8 }}>◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
